import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
// reactstrap components
import { Container, Row } from 'reactstrap';

import { connect } from 'react-redux';

// core components
import AuthNavbar from '../components/Navbars/AuthNavbar.jsx';

import routes from '../routes.js';

class Auth extends React.Component {
  componentDidMount() {
    document.body.classList.add('bg-default');
  }
  componentWillUnmount() {
    document.body.classList.remove('bg-default');
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        const Component = prop.component;
        return (
          <Route
            path={prop.path}
            element={<Component />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  render() {
    let userAuth = JSON.parse(localStorage.getItem('userAuth'));
    if (userAuth !== null) {
         return (
          <Navigate to="/admin/index" replace />
        ); 
    }
    return (
      <>
        <div className="main-content">
          <AuthNavbar />
          <div className="header bg-gradient-info py-7 py-lg-8">
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-default"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </div>
          {/* Page content */}
          <Container className="mt--8 pb-5">
            <Row className="justify-content-center">
              <Routes>{this.getRoutes(routes)}</Routes>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps, {})(Auth);
